import React from 'react';
import { useLocation } from "@reach/router";
import { Link } from 'gatsby';
import FacebookIcon from '../images/facebookBlack.webp';
import InstagramIcon from '../images/instagramBlack.webp';
import LinkedinIcon from '../images/linkedinBlack.webp';
import '../css/components/styles.css';
import Logo from '../images/logo-blanco.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import headerBars from '../images/menu-white.webp';
import youtubeIcon from '../images/youtube.webp';

function Header() {
  const { pathname } = useLocation();

  // Ejemplo de cómo usar useStaticQuery para obtener datos, como el título del sitio.
  // Puedes ajustar esta consulta según tus necesidades.
 
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [showSubMenu, setShowSubMenu] = React.useState(false);
  const [menuActive, setMenuActive] = React.useState(false);

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleSwitchBodyActive = (bodyName) => {
    setMenuActive(bodyName);
  };

  // Verifica si la página actual es la página de inicio
  const isHomePage = pathname === '/';

  return (
    <>
      <header className={`Header `}>
        <div className="container">
          <div className="Header__container">
            <div className="Header__logo">
              <Link to="/">
                <img src={Logo} alt="logo" width="190" height="91" />
              </Link>
            </div>
            <div className="Header__navmenu">
              <ul>
                <li>
                  <Link to="/"><span>Inicio</span></Link>
                </li>
                <li>
                  <Link to="/nosotros"><span>Nosotros</span></Link>
                </li>
                <li
                  onMouseEnter={ () => setShowSubMenu(true) }
                  onMouseLeave={ () => setShowSubMenu(false) }
                >
                    <span>Servicios</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                  <div className={`subMenuContent ${showSubMenu ? 'subMenuContentActive' : ''}`}>
                    <ul>
                      <li>
                        {/* <a href="/servicios#sameday">Envíos SameDay</a> */}
                        <a href="/servicios/same-day">Envíos SameDay</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#mercadolibre">MercadoLibre Flex</a> */}
                        <a href="/servicios/mercado-envios-flex">MercadoLibre Flex</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#mercadolibre">MercadoLibre Flex</a> */}
                        <a href="/servicios/falabella-directo">Falabella Directo</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#nextday">Envíos NextDay</a> */}
                        <a href="/servicios/next-day">Envíos NextDay</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#logisticainversa">Logística Inversa</a> */}
                        <a href="/servicios/logistica-inversa">Logística Inversa</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#zonasrurales">Suburbano</a> */}
                        <a href="/servicios/suburbano">Suburbano</a>
                      </li>
                      <li>
                        {/* <a href="/servicios#zonasrurales">Suburbano</a> */}
                        <a href="/servicios/red-de-acopio">Red De Acopio</a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link to="/seguimiento"><span>Seguimiento</span></Link>
                </li>
                <li>
                  <Link to="/dashboard"><span>Dashboard</span></Link>
                </li>
                <li>
                  <Link to="/contacto"><span>Contacto</span></Link>
                </li>
                <li>
                  <a href="https://dashboard.recibelo.cl" target="_blank"><span>Login</span></a>
                </li>
              </ul>
            </div>
            <div className="Header__bars" onClick={handleMenuClick}>
              <img src={headerBars} alt="mobile-burger-icon" width="32" height="32" />
            </div>
          </div>
        </div>
      </header>
      <div className="Content__mobileMenu">
          <div className="container">
              <div className={`Content__mobileMenu--container ${menuOpen ? "menuActive" : ""}`}>
                  <div className="Content__mobileMenu--nav">
                      <ul>
                          <li className="linkMenu linkActive">
                            <div className="currentPosition">
                              <FontAwesomeIcon icon={faChevronLeft} style={{opacity: `${showSubMenu ? "1" : "0"}`}} onClick={ () => setShowSubMenu(false) } />
                              <span>Menu</span>
                            </div>
                          </li>
                      </ul>
                  </div>
                  <div className="Content__mobileMenu--mainNavs">
                      <div className={`Content__mobileMenu--mainNavs-nav ${showSubMenu == true ? "bodyActive2" : ""}`}>
                          <ul className="menu">
                            <li>
                              <a href="/servicios/same-day">Envíos SameDay</a>
                            </li>
                            <li>
                              <a href="/servicios/mercado-envios-flex">MercadoLibre Flex</a>
                            </li>
                            <li>
                              <a href="/servicios/falabella-directo">Falabella Directo</a>
                            </li>
                            <li>
                              <a href="/servicios/next-day">Envíos NextDay</a>
                            </li>
                            <li>
                              <a href="/servicios/logistica-inversa">Logística Inversa</a>
                            </li>
                            <li>
                              <a href="/servicios/suburbano">Suburbano</a>
                            </li>
                            <li>
                              <a href="/servicios/red-de-acopio">Red De Acopio</a>
                            </li>
                          </ul>
                      </div>
                      <div className={`Content__mobileMenu--mainNavs-nav ${showSubMenu == false ? "bodyActive2" : ""}`}>
                          <ul className="menu">
                            <li>
                              <Link to="/">Inicio</Link>
                            </li>
                            <li>
                              <Link to="/nosotros">Nosotros</Link>
                            </li>
                            <li 
                              onClick={ () => setShowSubMenu(true) }
                            >
                              <p>Servicios <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg></p>
                            </li>
                            <li>
                              <Link to="/seguimiento">Seguimiento</Link>
                            </li>
                            <li>
                              <Link to="/dashboard">Dashboard</Link>
                            </li>
                            <li>
                              <Link to="/contacto">Contacto</Link>
                            </li>
                            <li>
                              <a href="https://dashboard.recibelo.cl" target="_blank"><span>Login</span></a>
                            </li>
                          </ul>
                      </div>
                  </div>
                  <div className="Content__mobileMenu--footer">
                    <a href="tel:+56921682134" className="Content__mobileMenu--footer-item">
                      <i className="fa-regular fa-envelope-open"></i>
                      <span>+56921682134</span>
                    </a>
                    <a href="mailto:ayuda@recibelo.cl" className="Content__mobileMenu--footer-item">
                      <i className="fa-solid fa-phone"></i>
                      <span>ayuda@recibelo.cl</span>
                    </a>
                    <div className="Content__mobileMenu--footer-socials">
                      <ul>
                          <li><a href="https://web.facebook.com/recibelocl" target="_blank"><img src={FacebookIcon} alt="facebook-logo" width="18" height="18" /></a></li>
                          <li><a href="https://www.instagram.com/recibelo.cl/" target="_blank"><img src={InstagramIcon} alt="instagram-logo" width="18" height="18" /></a></li>
                          <li><a href="https://www.linkedin.com/company/recibelo" target="_blank"><img src={LinkedinIcon} alt="linkedin-logo" width="18" height="18" /></a></li>
                          <li><a href="https://www.youtube.com/channel/UCbrOUkbT1JCWatCt5jx7WZw" target="_blank"><img src={youtubeIcon} alt="youtube-logo" width="18" height="18" /></a></li>
                      </ul>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div className={`overlay ${menuOpen ? "overlayActive" : ""}`} onClick={handleMenuClick}></div>
    </>
  );
}

export { Header };
